module.exports = __webpack_public_path__ + "img/ic_premium.c4ca3719.png";